import every from 'lodash/every';
import keys from 'lodash/keys';
import map from 'lodash/map';

export interface DomainError {
  attr?: string;
  code: Code;
  detail?: string;
  meta?: object;
}

const codeList = [
  'blank',
  'invalid',
  'invalid_state',
  'moved',
  'not_exist',
  'operation_failed',
  'present',
  'taken',
  'too_short',
  'too_long',
  'not_a_number',
  'greater_than',
  'less_than_or_equal_to',
  'in_use',
  'unexpected_error',
  'version_outdated',
  'wrong_length',
] as const;
export type Code = (typeof codeList)[number];

export function matchesError(error, template) {
  return every(map(keys(template), key => template[key] === error[key]));
}
